import React from 'react';
import { connect } from 'react-redux';
import { login, continueAsGuest } from './LoginActions';
import Login from '../../components/Authentication/Login';
import { Redirect } from 'react-router-dom';


/**
 * Container component for logging in
 */
class LoginContainer extends React.Component {

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      submittedOnce: false,
      error: false
    };
  }

  onSubmit(values) {
    let { dispatchLogin } = this.props;
    this.setState({
      submittedOnce: true
    });

    dispatchLogin(values.email, values.password, (err, result) => {
      if (err) {
        this.setState({
          error: err.message
        });
      }
    });
  }

  render() {
    let { login, dispatchContinueAsGuest } = this.props;
    login = login.toObject();
    let { submittedOnce, error } = this.state;

    if (login.isAuthenticated) {
      return (
        <Redirect to="/dashboard" push />
      );
    }

    let errorText = null;
    if (error && submittedOnce) {
      errorText = login.error;
    }
    return (
      <div>
        <Login 
        dispatchContinueAsGuest={dispatchContinueAsGuest} 
        errorText={errorText} onSubmit={this.onSubmit} />
      </div>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    dispatchLogin: (email, password, cb) => { dispatch(login(email, password, cb)); },
    dispatchContinueAsGuest: () => { dispatch(continueAsGuest()); }
  };
};

function mapStateToProps(state) {
  return {
    login: state.authentication.login
    //error: tate.authorization.login.get('error'),
    //isAuthenticated: tate.authorization.login.get('isAuthenticated')
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);


// WEBPACK FOOTER //
// ./src/containers/Authentication/LoginContainer.js